import { AppointmentStatus } from '@lingoda/monolith-graphql';

export const getClassIsMissed = (appointmentStatus: AppointmentStatus | undefined) => {
    return appointmentStatus === AppointmentStatus.Missed;
};
